/* Jellyflow cart drawer extras: add buttons + free shipping bar for non-USD currencies.
   Loaded site-wide because the drawer lives on every page and is re-rendered on each cart update. */
(function () {
  if (window.__jfCartDrawer) return;
  window.__jfCartDrawer = true;

  async function add(btn) {
    const id = btn.getAttribute('data-jf-cart-add');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const actions = window.Shopify && window.Shopify.actions;
      if (actions && typeof actions.updateCart === 'function') {
        const r = await actions.updateCart({ lines: [{ merchandiseId: id, quantity: 1 }] }, { event: { context: 'cart' } });
        if (r && r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
        if (btn.hasAttribute('data-jf-cart-open') && typeof actions.openCart === 'function') actions.openCart().catch(() => {});
      } else {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) });
        if (!res.ok) throw new Error('Could not add');
        window.location.reload();
      }
    } catch (e) {
      btn.classList.add('is-error');
      setTimeout(() => btn.classList.remove('is-error'), 1500);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('button[data-jf-cart-add]') : null;
    if (btn) { e.preventDefault(); add(btn); }
  });

  // The free shipping threshold is set in USD. Shopify converts it at checkout, so mirror that for other currencies.
  function paintGoal(el) {
    const cur = window.Shopify && window.Shopify.currency;
    const rate = cur && parseFloat(cur.rate);
    if (!cur || !rate) return;
    const goal = Math.ceil(parseFloat(el.dataset.usdGoal) * rate) * 100;
    const total = parseInt(el.dataset.total, 10) || 0;
    const left = Math.max(goal - total, 0);
    const out = el.querySelector('[data-jf-goal-left]');
    const fill = el.querySelector('[data-jf-goal-fill]');
    if (out) {
      // Reuse the store's own money format: swap the number inside the server-rendered amount.
      const tpl = out.textContent.trim();
      const comma = /,\d{2}(?!\d)/.test(tpl);
      const flat = !/[.,]\d{2}(?!\d)/.test(tpl);
      let num = flat ? String(Math.ceil(left / 100)) : (left / 100).toFixed(2);
      if (comma) num = num.replace('.', ',');
      out.textContent = /\d/.test(tpl) ? tpl.replace(/\d[\d.,]*/, num) : num + ' ' + cur.active;
    }
    if (fill) fill.style.width = Math.min(100, Math.round((total / goal) * 100)) + '%';
    el.classList.toggle('is-unlocked', left <= 0);
    el.removeAttribute('data-pending');
  }

  // Sale countdown: mirrors the PDP promo block (it publishes jf-promo-live), never starts a timer of its own.
  function salePromo() {
    try { return JSON.parse(localStorage.getItem('jf-promo-live') || 'null'); } catch (e) { return null; }
  }
  const pad = (n) => String(n).padStart(2, '0');
  function paintTimers() {
    const els = document.querySelectorAll('[data-jf-cart-timer]');
    if (!els.length) return;
    const promo = salePromo();
    const left = promo && promo.heading ? Math.floor((promo.end - Date.now()) / 1000) : 0;
    els.forEach((el) => {
      if (left <= 0) { if (!el.hidden) el.hidden = true; return; }
      const d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      const txt = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      const out = el.querySelector('[data-jf-cart-timer-out]');
      if (out && out.textContent !== txt) out.textContent = txt;
      const label = el.querySelector('[data-jf-cart-timer-label]');
      if (label && label.textContent !== promo.heading) label.textContent = promo.heading;
      if (promo.bg) el.style.background = promo.bg;
      if (promo.fg) el.style.color = promo.fg;
      if (label && promo.accent) label.style.color = promo.accent;
      if (el.hidden) el.hidden = false;
    });
  }

  // Review quotes: fade to the next one every 6s while the drawer is open.
  let revTick = 0;
  function rotateReviews() {
    const box = document.querySelector('theme-drawer#cart-drawer [data-jf-revs]');
    if (!box || !box.offsetParent || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (++revTick % 6) return;
    const cards = [...box.children]; if (cards.length < 2) return;
    const i = cards.findIndex((c) => c.classList.contains('is-on'));
    const next = cards[(i + 1) % cards.length];
    cards.forEach((c) => { c.classList.toggle('is-on', c === next); c.setAttribute('aria-hidden', String(c !== next)); });
  }

  // Omnisend welcome popup: once the cart has items, mark it as just closed so it never interrupts a shopper who is buying.
  // Omnisend reads these cookies with the form's 7-day frequency. The ids are the welcome popup plus its two A/B test variants;
  // add the new id if the popup is ever replaced.
  const JF_POPUP_IDS = ['6888d02d1ebfa09f790b5500', '6ab10cc60c62cd332a446452', '6ab10cc60c62cd332a446453'];
  function quietPopup() {
    if (!document.querySelector('theme-drawer#cart-drawer .cart-items__table-row')) return;
    JF_POPUP_IDS.forEach((id) => {
      const name = 'omnisend-form-' + id + '-closed-at';
      if (document.cookie.indexOf(name + '=') === -1) document.cookie = name + '=' + new Date().toISOString() + '; path=/; max-age=' + 7 * 86400 + '; SameSite=Lax';
    });
  }

  function sweep() { document.querySelectorAll('[data-jf-goal][data-pending]').forEach(paintGoal); paintTimers(); quietPopup(); }

  function init() {
    sweep();
    const host = document.querySelector('theme-drawer#cart-drawer') || document.body;
    new MutationObserver(sweep).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-pending'] });
    setInterval(() => { paintTimers(); rotateReviews(); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
